const Redirect = () => {
    return <h2 className="center-box">
        Redirect... Please Wait...
    </h2>
}

export default Redirect
